// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import LectureLessonListPagingResultSchema from './lecture-lesson-list-paging-result-schema';
import Int64LookupListResultSchema from './int64-lookup-list-result-schema';

const schema = {
  $id: '/lecture-lesson-list-module-list-schema',
  type: 'object',
  required: [],
  properties: {
    lessons: {
      ...LectureLessonListPagingResultSchema,
    },
    modules: {
      ...Int64LookupListResultSchema,
    },
  },
} as IJSONSchema;

export default schema;
